// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: var(--surface-primary);
  border-right: 1px solid var(--border-default);
  transition: width 0.3s ease-in-out;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}

.sidebar-expanded {
  width: 16rem;
}

.sidebar-collapsed {
  width: 4rem;
}

.sidebar-hidden {
  transform: translateX(-100%);
}

.sidebar-mobile-fullwidth {
  width: 100%;
}

.sidebar-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.5rem;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background 0.12s;
  flex-shrink: 0;
}
.sidebar-close-btn:hover {
  background: var(--surface-color);
}

.sidebar-backdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
  background: rgba(0, 0, 0, 0.5);
}

.sidebar-header {
  display: flex;
  height: 4rem;
  align-items: center;
  gap: 0.75rem;
  padding: 0 1rem;
  border-bottom: 1px solid var(--border-default);
  flex-shrink: 0;
}

.sidebar-brand-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.sidebar-wordmark {
  display: block;
  height: 0.5rem;
  width: auto;
  flex-shrink: 0;
}

.sidebar-wordmark-dark {
  display: none;
}

:host-context(body.dark) .sidebar-wordmark-light {
  display: none;
}

:host-context(body.dark) .sidebar-wordmark-dark {
  display: block;
}

.sidebar-brand-accent {
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-accent);
  line-height: 1;
}

.sidebar-product-switcher {
  position: relative;
}

.sidebar-product-trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.125rem;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--color-accent);
  font-family: "Inter", system-ui, sans-serif;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
  transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sidebar-product-trigger:hover {
  opacity: 0.8;
}

.sidebar-product-chevron {
  width: 0.875rem;
  height: 0.875rem;
  flex-shrink: 0;
  transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sidebar-product-chevron.rotated {
  transform: rotate(180deg);
}

.sidebar-product-menu {
  position: absolute;
  top: 100%;
  left: -0.75rem;
  margin-top: 0.25rem;
  z-index: 50;
  min-width: 8rem;
  border-radius: 0.5rem;
  border: 1px solid var(--border-default);
  background: var(--surface-primary);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.sidebar-product-item {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  font-family: "Inter", system-ui, sans-serif;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
  color: var(--color-accent);
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  white-space: nowrap;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sidebar-product-item:hover {
  background: var(--surface-color);
}

.sidebar-collapsed-letter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-accent);
}

.sidebar-header-group:hover .sidebar-collapse-hover {
  opacity: 1;
}
.sidebar-header-group:hover .sidebar-collapsed-logo {
  opacity: 0;
}
.sidebar-header-group:hover .sidebar-collapsed-expand {
  opacity: 1;
}

.sidebar-collapse-btn, .sidebar-expand-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.5rem;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  cursor: w-resize;
  transition: background 0.12s, opacity 0.2s;
  flex-shrink: 0;
}
.sidebar-collapse-btn:hover, .sidebar-expand-btn:hover {
  background: var(--surface-color);
}

.sidebar-collapse-hover {
  opacity: 0;
}

.sidebar-expand-btn {
  margin: 0 auto;
  cursor: e-resize;
}

.sidebar-collapse-icon {
  width: 1.25rem;
  height: 1.25rem;
}

.sidebar-collapsed-header-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  margin: 0 auto;
}
.sidebar-collapsed-header-wrapper[data-tooltip]::after {
  content: attr(data-tooltip);
  position: fixed;
  left: 4.5rem;
  padding: 0.25rem 0.5rem;
  background: #030712;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 400;
  border-radius: 0.5rem;
  border: 1px solid #111827;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s;
  z-index: 100;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
}
.sidebar-collapsed-header-wrapper[data-tooltip]:hover::after {
  opacity: 1;
}

.sidebar-collapsed-logo {
  transition: opacity 0.2s;
}

.sidebar-collapsed-expand {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
  margin: 0;
  width: 100%;
  height: 100%;
}

.sidebar-nav {
  flex: 1;
  overflow-y: auto;
  padding: 0.75rem 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.sidebar-nav-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: var(--sidebar-text);
  background: transparent;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition: background 0.12s, color 0.12s;
  font-family: "Inter", system-ui, sans-serif;
}
.sidebar-nav-item:hover {
  background: var(--sidebar-hover);
  color: var(--sidebar-text-bright);
}

.sidebar-nav-item-active {
  background: var(--sidebar-selected);
  color: var(--sidebar-selected-text);
}
.sidebar-nav-item-active:hover {
  background: var(--sidebar-selected);
  color: var(--sidebar-selected-text);
}

.sidebar-icon {
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
}

.sidebar-collapsed .sidebar-nav-item {
  justify-content: center;
  padding: 0.5rem;
}
.sidebar-collapsed .sidebar-user-btn {
  justify-content: center;
}
.sidebar-collapsed .sidebar-nav-item,
.sidebar-collapsed .sidebar-user-btn {
  position: relative;
  overflow: visible;
}
.sidebar-collapsed .sidebar-nav-item[data-tooltip]::after,
.sidebar-collapsed .sidebar-user-btn[data-tooltip]::after {
  content: attr(data-tooltip);
  position: fixed;
  left: 4.5rem;
  padding: 0.25rem 0.5rem;
  background: #030712;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 400;
  border-radius: 0.5rem;
  border: 1px solid #111827;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s;
  z-index: 100;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
}
.sidebar-collapsed .sidebar-nav-item[data-tooltip]:hover::after,
.sidebar-collapsed .sidebar-user-btn[data-tooltip]:hover::after {
  opacity: 1;
}

.sidebar-help {
  flex-shrink: 0;
  padding: 0 0.5rem 0.5rem;
}

.sidebar-bottom {
  border-top: 1px solid var(--border-default);
  padding: 0.75rem 0.5rem;
  flex-shrink: 0;
  position: relative;
}

.sidebar-user-btn {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.75rem;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: var(--text-primary);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background 0.12s;
  font-family: "Inter", system-ui, sans-serif;
}
.sidebar-user-btn:hover {
  background: var(--sidebar-hover);
}

.sidebar-user-avatar {
  display: flex;
  width: 1.75rem;
  height: 1.75rem;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  background: #4c17ca;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
}

.sidebar-user-avatar-img {
  display: block;
  width: 1.75rem;
  height: 1.75rem;
  flex-shrink: 0;
  border-radius: 0.5rem;
  object-fit: cover;
}

.sidebar-user-name-wrapper {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.sidebar-user-name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.sidebar-user-org {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--text-secondary);
}

.sidebar-user-chevron {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  color: var(--text-secondary);
}

.sidebar-popover {
  position: absolute;
  left: 0.5rem;
  bottom: 100%;
  z-index: 30;
  margin-bottom: 0.25rem;
  border-radius: 0.5rem;
  border: 1px solid var(--border-default);
  background: var(--surface-primary);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  padding: 0.25rem 0;
  min-width: 14rem;
  width: max-content;
  max-width: calc(100% - 1rem);
}

.sidebar-popover-item {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--text-primary);
  background: none;
  border: none;
  cursor: pointer;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1), color 150ms cubic-bezier(0.4, 0, 0.2, 1);
  font-family: "Inter", system-ui, sans-serif;
  text-decoration: none;
}
.sidebar-popover-item:hover {
  background: var(--surface-color);
}

.sidebar-popover-icon {
  width: 1.125rem;
  height: 1.125rem;
  flex-shrink: 0;
}

.sidebar-popover-item-text {
  flex: 1;
  text-align: left;
}

.sidebar-popover-chevron {
  width: 0.875rem;
  height: 0.875rem;
  flex-shrink: 0;
  color: var(--text-secondary);
}

.sidebar-popover-disconnect {
  color: oklch(63.7% 0.237 25.331deg);
}
.sidebar-popover-disconnect .sidebar-popover-icon {
  color: oklch(63.7% 0.237 25.331deg);
}
.sidebar-popover-disconnect:hover {
  background: oklch(63.7% 0.237 25.331deg / 0.1);
}

.sidebar-popover-divider {
  height: 1px;
  background: var(--border-default);
  margin: 0.25rem 0;
}

.sidebar-popover-credits {
  cursor: default;
}
.sidebar-popover-credits:hover {
  background: transparent;
}

.sidebar-popover-credits-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.sidebar-popover-credits-label {
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--text-secondary);
}

.sidebar-popover-credits-value {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: var(--text-primary);
}

.sidebar-popover-org {
  position: relative;
}

.sidebar-org-submenu {
  position: absolute;
  left: 100%;
  bottom: 0;
  z-index: 40;
  width: 14rem;
  max-height: 16rem;
  overflow-y: auto;
  border-radius: 0.5rem;
  border: 1px solid var(--border-default);
  background: var(--surface-primary);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  padding: 0.25rem 0;
}

.sidebar-org-item {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-primary);
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1), color 150ms cubic-bezier(0.4, 0, 0.2, 1);
  font-family: "Inter", system-ui, sans-serif;
}
.sidebar-org-item:hover {
  background: var(--surface-color);
}

.sidebar-org-item-active {
  color: var(--color-accent);
  font-weight: 500;
}

.sidebar-org-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar-org-check {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  color: var(--color-accent);
}`, "",{"version":3,"sources":["webpack://./src/app/components/icon-rail/icon-rail.component.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kCAAA;EACA,6CAAA;EACA,kCAAA;EACA,4BAAA;EACA,6BAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,4BAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;EACA,4BAAA;EACA,cAAA;AADF;AAGE;EACE,gCAAA;AADJ;;AAOA;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;AAJF;;AASA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,8CAAA;EACA,cAAA;AANF;;AASA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AANF;;AASA;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;AANF;;AASA;EACE,aAAA;AANF;;AASA;EACE,aAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;AANF;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;EACA,2CAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,sDAAA;AAPF;AASE;EACE,YAAA;AAPJ;;AAWA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,wDAAA;AARF;AAUE;EACE,yBAAA;AARJ;;AAYA;EACE,kBAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,uCAAA;EACA,kCAAA;EACA,kFAAA;EACA,gBAAA;AATF;;AAYA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,2CAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,+DAAA;AATF;AAWE;EACE,gCAAA;AATJ;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;AAVF;;AAeI;EACE,UAAA;AAZN;AAeI;EACE,UAAA;AAbN;AAgBI;EACE,UAAA;AAdN;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,4BAAA;EACA,gBAAA;EACA,0CAAA;EACA,cAAA;AAhBF;AAkBE;EACE,gCAAA;AAhBJ;;AAoBA;EACE,UAAA;AAjBF;;AAoBA;EAEE,cAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAlBF;AAoBE;EACE,2BAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,kFAAA;AAlBJ;AAqBE;EACE,UAAA;AAnBJ;;AAuBA;EACE,wBAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,wBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AApBF;;AAyBA;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,yCAAA;EACA,2CAAA;AAtBF;AAwBE;EACE,gCAAA;EACA,iCAAA;AAtBJ;;AA0BA;EACE,mCAAA;EACA,mCAAA;AAvBF;AAyBE;EACE,mCAAA;EACA,mCAAA;AAvBJ;;AA2BA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAxBF;;AA4BE;EACE,uBAAA;EACA,eAAA;AAzBJ;AA4BE;EACE,uBAAA;AA1BJ;AA6BE;;EAEE,kBAAA;EACA,iBAAA;AA3BJ;AA6BI;;EACE,2BAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,kFAAA;AA1BN;AA6BI;;EACE,UAAA;AA1BN;;AAiCA;EACE,cAAA;EACA,wBAAA;AA9BF;;AAmCA;EACE,2CAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;EACA,2CAAA;AAhCF;AAkCE;EACE,gCAAA;AAhCJ;;AAqCA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAlCF;;AAqCA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;AAlCF;;AAqCA;EACE,OAAA;EACA,YAAA;EACA,gBAAA;AAlCF;;AAqCA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AAlCF;;AAqCA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,4BAAA;AAlCF;;AAqCA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,4BAAA;AAlCF;;AAuCA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,uCAAA;EACA,kCAAA;EACA,kFAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;AApCF;;AAuCA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,yGAAA;EACA,2CAAA;EACA,qBAAA;AApCF;AAsCE;EACE,gCAAA;AApCJ;;AAwCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AArCF;;AAwCA;EACE,OAAA;EACA,gBAAA;AArCF;;AAwCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;AArCF;;AAwCA;EACE,mCAAA;AArCF;AAuCE;EACE,mCAAA;AArCJ;AAwCE;EACE,8CAAA;AAtCJ;;AA0CA;EACE,WAAA;EACA,iCAAA;EACA,iBAAA;AAvCF;;AA0CA;EACE,eAAA;AAvCF;AAyCE;EACE,uBAAA;AAvCJ;;AA2CA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;AAxCF;;AA2CA;EACE,kBAAA;EACA,iBAAA;EACA,4BAAA;AAxCF;;AA2CA;EACE,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,0BAAA;AAxCF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uCAAA;EACA,kCAAA;EACA,+CAAA;EACA,kBAAA;AA1CF;;AA6CA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;EACA,yGAAA;EACA,2CAAA;AA1CF;AA4CE;EACE,gCAAA;AA1CJ;;AA8CA;EACE,0BAAA;EACA,gBAAA;AA3CF;;AA8CA;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA3CF;;AA8CA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;AA3CF","sourcesContent":["// ─── Sidebar — exact match of admin-console ───\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 50;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background: var(--surface-primary);\n  border-right: 1px solid var(--border-default);\n  transition: width 0.3s ease-in-out;\n  -webkit-font-smoothing: auto;\n  -moz-osx-font-smoothing: auto;\n}\n\n.sidebar-expanded {\n  width: 16rem;\n}\n\n.sidebar-collapsed {\n  width: 4rem;\n}\n\n.sidebar-hidden {\n  transform: translateX(-100%);\n}\n\n.sidebar-mobile-fullwidth {\n  width: 100%;\n}\n\n.sidebar-close-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.25rem;\n  height: 2.25rem;\n  border-radius: 0.5rem;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: background 0.12s;\n  flex-shrink: 0;\n\n  &:hover {\n    background: var(--surface-color);\n  }\n}\n\n// ─── Mobile backdrop ───\n\n.sidebar-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 40;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n// ─── Header ───\n\n.sidebar-header {\n  display: flex;\n  height: 4rem;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0 1rem;\n  border-bottom: 1px solid var(--border-default);\n  flex-shrink: 0;\n}\n\n.sidebar-brand-wrap {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 0;\n}\n\n.sidebar-wordmark {\n  display: block;\n  height: 0.5rem;\n  width: auto;\n  flex-shrink: 0;\n}\n\n.sidebar-wordmark-dark {\n  display: none;\n}\n\n:host-context(body.dark) .sidebar-wordmark-light {\n  display: none;\n}\n\n:host-context(body.dark) .sidebar-wordmark-dark {\n  display: block;\n}\n\n.sidebar-brand-accent {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--color-accent);\n  line-height: 1;\n}\n\n// Product switcher (matches admin-console)\n.sidebar-product-switcher {\n  position: relative;\n}\n\n.sidebar-product-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.125rem;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--color-accent);\n  font-family: 'Inter', system-ui, sans-serif;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 600;\n  transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);\n\n  &:hover {\n    opacity: 0.8;\n  }\n}\n\n.sidebar-product-chevron {\n  width: 0.875rem;\n  height: 0.875rem;\n  flex-shrink: 0;\n  transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1);\n\n  &.rotated {\n    transform: rotate(180deg);\n  }\n}\n\n.sidebar-product-menu {\n  position: absolute;\n  top: 100%;\n  left: -0.75rem;\n  margin-top: 0.25rem;\n  z-index: 50;\n  min-width: 8rem;\n  border-radius: 0.5rem;\n  border: 1px solid var(--border-default);\n  background: var(--surface-primary);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.sidebar-product-item {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem 0.75rem;\n  font-family: 'Inter', system-ui, sans-serif;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 600;\n  color: var(--color-accent);\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  white-space: nowrap;\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1);\n\n  &:hover {\n    background: var(--surface-color);\n  }\n}\n\n.sidebar-collapsed-letter {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--color-accent);\n}\n\n.sidebar-header-group {\n  &:hover {\n    .sidebar-collapse-hover {\n      opacity: 1;\n    }\n\n    .sidebar-collapsed-logo {\n      opacity: 0;\n    }\n\n    .sidebar-collapsed-expand {\n      opacity: 1;\n    }\n  }\n}\n\n.sidebar-collapse-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.25rem;\n  height: 2.25rem;\n  border-radius: 0.5rem;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: w-resize;\n  transition: background 0.12s, opacity 0.2s;\n  flex-shrink: 0;\n\n  &:hover {\n    background: var(--surface-color);\n  }\n}\n\n.sidebar-collapse-hover {\n  opacity: 0;\n}\n\n.sidebar-expand-btn {\n  @extend .sidebar-collapse-btn;\n  margin: 0 auto;\n  cursor: e-resize;\n}\n\n.sidebar-collapse-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.sidebar-collapsed-header-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.25rem;\n  height: 2.25rem;\n  margin: 0 auto;\n\n  &[data-tooltip]::after {\n    content: attr(data-tooltip);\n    position: fixed;\n    left: calc(4rem + 0.5rem);\n    padding: 0.25rem 0.5rem;\n    background: #030712;\n    color: #fff;\n    font-size: 0.75rem;\n    font-weight: 400;\n    border-radius: 0.5rem;\n    border: 1px solid #111827;\n    white-space: nowrap;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.15s;\n    z-index: 100;\n    box-shadow: 0 10px 15px -3px rgba(0,0,0,.1), 0 4px 6px -4px rgba(0,0,0,.1);\n  }\n\n  &[data-tooltip]:hover::after {\n    opacity: 1;\n  }\n}\n\n.sidebar-collapsed-logo {\n  transition: opacity 0.2s;\n}\n\n.sidebar-collapsed-expand {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.2s;\n  margin: 0;\n  width: 100%;\n  height: 100%;\n}\n\n// ─── Nav ───\n\n.sidebar-nav {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0.75rem 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.sidebar-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  border-radius: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 500;\n  color: var(--sidebar-text);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  transition: background 0.12s, color 0.12s;\n  font-family: 'Inter', system-ui, sans-serif;\n\n  &:hover {\n    background: var(--sidebar-hover);\n    color: var(--sidebar-text-bright);\n  }\n}\n\n.sidebar-nav-item-active {\n  background: var(--sidebar-selected);\n  color: var(--sidebar-selected-text);\n\n  &:hover {\n    background: var(--sidebar-selected);\n    color: var(--sidebar-selected-text);\n  }\n}\n\n.sidebar-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  flex-shrink: 0;\n}\n\n.sidebar-collapsed {\n  .sidebar-nav-item {\n    justify-content: center;\n    padding: 0.5rem;\n  }\n\n  .sidebar-user-btn {\n    justify-content: center;\n  }\n\n  .sidebar-nav-item,\n  .sidebar-user-btn {\n    position: relative;\n    overflow: visible;\n\n    &[data-tooltip]::after {\n      content: attr(data-tooltip);\n      position: fixed;\n      left: calc(4rem + 0.5rem);\n      padding: 0.25rem 0.5rem;\n      background: #030712;\n      color: #fff;\n      font-size: 0.75rem;\n      font-weight: 400;\n      border-radius: 0.5rem;\n      border: 1px solid #111827;\n      white-space: nowrap;\n      opacity: 0;\n      pointer-events: none;\n      transition: opacity 0.15s;\n      z-index: 100;\n      box-shadow: 0 10px 15px -3px rgba(0,0,0,.1), 0 4px 6px -4px rgba(0,0,0,.1);\n    }\n\n    &[data-tooltip]:hover::after {\n      opacity: 1;\n    }\n  }\n}\n\n// ─── Help (pinned above the bottom user section, no border) ───\n\n.sidebar-help {\n  flex-shrink: 0;\n  padding: 0 0.5rem 0.5rem;\n}\n\n// ─── Bottom section ───\n\n.sidebar-bottom {\n  border-top: 1px solid var(--border-default);\n  padding: 0.75rem 0.5rem;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.sidebar-user-btn {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 0.75rem;\n  border-radius: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: background 0.12s;\n  font-family: 'Inter', system-ui, sans-serif;\n\n  &:hover {\n    background: var(--sidebar-hover);\n  }\n}\n\n\n.sidebar-user-avatar {\n  display: flex;\n  width: 1.75rem;\n  height: 1.75rem;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.5rem;\n  background: #4c17ca;\n  color: #ffffff;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.sidebar-user-avatar-img {\n  display: block;\n  width: 1.75rem;\n  height: 1.75rem;\n  flex-shrink: 0;\n  border-radius: 0.5rem;\n  object-fit: cover;\n}\n\n.sidebar-user-name-wrapper {\n  flex: 1;\n  min-width: 0;\n  text-align: left;\n}\n\n.sidebar-user-name {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.sidebar-user-org {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: var(--text-secondary);\n}\n\n.sidebar-user-chevron {\n  width: 1rem;\n  height: 1rem;\n  flex-shrink: 0;\n  color: var(--text-secondary);\n}\n\n// ─── Popover ───\n\n.sidebar-popover {\n  position: absolute;\n  left: 0.5rem;\n  bottom: 100%;\n  z-index: 30;\n  margin-bottom: 0.25rem;\n  border-radius: 0.5rem;\n  border: 1px solid var(--border-default);\n  background: var(--surface-primary);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);\n  padding: 0.25rem 0;\n  min-width: 14rem;\n  width: max-content;\n  max-width: calc(100% - 1rem);\n}\n\n.sidebar-popover-item {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  color: var(--text-primary);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1), color 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  font-family: 'Inter', system-ui, sans-serif;\n  text-decoration: none;\n\n  &:hover {\n    background: var(--surface-color);\n  }\n}\n\n.sidebar-popover-icon {\n  width: 1.125rem;\n  height: 1.125rem;\n  flex-shrink: 0;\n}\n\n.sidebar-popover-item-text {\n  flex: 1;\n  text-align: left;\n}\n\n.sidebar-popover-chevron {\n  width: 0.875rem;\n  height: 0.875rem;\n  flex-shrink: 0;\n  color: var(--text-secondary);\n}\n\n.sidebar-popover-disconnect {\n  color: oklch(63.7% 0.237 25.331);\n\n  .sidebar-popover-icon {\n    color: oklch(63.7% 0.237 25.331);\n  }\n\n  &:hover {\n    background: oklch(63.7% 0.237 25.331 / 0.1);\n  }\n}\n\n.sidebar-popover-divider {\n  height: 1px;\n  background: var(--border-default);\n  margin: 0.25rem 0;\n}\n\n.sidebar-popover-credits {\n  cursor: default;\n\n  &:hover {\n    background: transparent;\n  }\n}\n\n.sidebar-popover-credits-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.sidebar-popover-credits-label {\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: var(--text-secondary);\n}\n\n.sidebar-popover-credits-value {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n// ─── Org submenu ───\n\n.sidebar-popover-org {\n  position: relative;\n}\n\n.sidebar-org-submenu {\n  position: absolute;\n  left: 100%;\n  bottom: 0;\n  z-index: 40;\n  width: 14rem;\n  max-height: 16rem;\n  overflow-y: auto;\n  border-radius: 0.5rem;\n  border: 1px solid var(--border-default);\n  background: var(--surface-primary);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  padding: 0.25rem 0;\n}\n\n.sidebar-org-item {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  text-align: left;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-primary);\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1), color 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  font-family: 'Inter', system-ui, sans-serif;\n\n  &:hover {\n    background: var(--surface-color);\n  }\n}\n\n.sidebar-org-item-active {\n  color: var(--color-accent);\n  font-weight: 500;\n}\n\n.sidebar-org-name {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sidebar-org-check {\n  width: 1rem;\n  height: 1rem;\n  flex-shrink: 0;\n  color: var(--color-accent);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
